<template>
    <div>
        <el-row>
            <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                    <el-card>
                        <div slot="header" class="com_header">
                            <el-col :span="12">
                                <div style="display: flex; align-items: center;">
                                    <span>举报类型：</span>
                                    <el-select @change="posts" clearable v-model="pageObj.reportType" placeholder="请选择">
                                        <el-option v-for="item in options" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <span style="margin-left: 20px;">审核状态：</span>
                                    <el-select @change="posts" clearable v-model="pageObj.reviewStatus"
                                        placeholder="请选择">
                                        <el-option v-for="item in options1" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>

                                    <!-- <el-input v-model="disabledName" class="w200 mr-15" placeholder="请输入被举报人" clearable
                                    @change="handleChange" style="margin-left: 20px;"></el-input> -->
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <el-button type="primary" @click="anchorPageList()">查询</el-button>
                                <el-button @click="resetForm()">重置</el-button>
                            </el-col>
                        </div>
                        <!-- <el-button type="primary" @click="updateText()">发布帖子</el-button> -->
                        <div v-if="isEmpty" v-loading="loading" class="com_cont">
                            <el-table :data="tableData" border height="95%">
                                <el-table-column label="举报人" prop="memberName" align="center"></el-table-column>
                                <el-table-column label="举报时间" prop="reportDate" align="center">
                                    <template slot-scope="scope">
                                        {{ dateformat(scope.row.reportDate) }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="举报类型" prop="reportType" align="center">
                                    <template slot-scope="scope">

                                        {{ scope.row.reportType == 0 ? "帖子举报" : "评论举报" }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="被举报人" prop="reportName" align="center">
                                </el-table-column>
                                <!-- <el-table-column label="评论数" prop="commentCount" align="center"></el-table-column>
            <el-table-column label="收藏数" prop="suggestFlag" align="center"></el-table-column> -->
                                <el-table-column label="举报原因" prop="reportContent" align="center">
                                </el-table-column>
                                <el-table-column label="审核状态" prop="reviewStatus" align="center">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.reviewStatus == 2"> 待审核</div>
                                        <div v-if="scope.row.reviewStatus == 1"> 审核未通过</div>
                                        <div v-if="scope.row.reviewStatus == 0"> 审核通过</div>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" label='操作' width="200">
                                    <template #default="{ row }">
                                        <el-button type="text" @click="handleEdit(row, '审核')">
                                            审核
                                        </el-button>
                                        <el-divider direction="vertical"></el-divider>
                                        <el-button type="text" @click="handleEdit(row, '查看')">
                                            查看
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination class="mt-15" @size-change="handleSizeChange"
                                @current-change="handleCurrentChange" :current-page.sync="page.index"
                                :page-sizes="page.sizes" :page-size.sync="pageObj.pageSize"
                                layout="total, sizes, prev, pager, next, jumper" :total="total">
                            </el-pagination>
                        </div>
                        <el-empty v-else></el-empty>

                    </el-card>
                </div>
            </el-col>
        </el-row>
        <edit ref="edit" />
    </div>
</template>

<script>
import Edit from './components/auditEdit.vue'
import moment from 'moment';
export default {
    name: 'AdminStaticsPostAudit',

    components: { Edit },
    mounted() {
        this.posts()
    },
    data() {
        return {
            isEmpty: true,
            loading: false,
            activeName: '1',
            tableData: [],
            isDisabled: false,
            page: {
                index: 0,
                sizes: [10, 20, 30, 40],
            },
            formData: {},
            // 分页传参
            pageObj: {
                pageNo: 0,
                pageSize: 10,
                reportType: '',
                reviewStatus: ''
            },
            total: '',
            // 发帖传参
            // pushObj: {
            //     postContent: "fgsdgdf",
            //     postName: "你好",
            //     memberId: 1,
            //     postType: 1,
            //     popularFlag: 1
            // },
            // 查询
            disabledName: '',
            options: [{
                value: '0',
                label: '帖子举报'
            }, {
                value: '1',
                label: '评论举报'
            }
            ],
            value: '1',
            options1: [{
                value: '1',
                label: '审核未通过'
            }, {
                value: '0',
                label: '审核通过'
            }, {
                value: '2',
                label: '待审核'
            }],
            value1: '1',
        };
    },
    methods: {
        resetForm() {
            this.pageObj = {
                pageNo: 0,
                pageSize: 10,
                reportType: '',
                reviewStatus: ''
            }
            this.posts()
        },
        dateformat(date) {
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        // 重置formData
        reData() {
            this.formData = {};
        },
        // 切换页码
        handleCurrentChange(index) {
            // this.pageObj.pageNo = index
            // this.posts()
            console.log(index, '页码');

        },
        // 切换每页条目数
        handleSizeChange(index) {
            this.pageObj.pageSize = index
            this.posts()
            console.log(index, '条数');
        },
        // 查询
        anchorPageList() {
            this.pageObj.postName = this.disabledName
            this.posts()
        },
        handleChange(val) {
            this.disabledName = val
        },
        // 
        posts() {
            this.loading = true
            this.$api.repotlist(this.pageObj).then((res) => {
                this.loading = false
                this.tableData = res.data.data.content
                this.total = res.data.data.totalElements
                if (this.tableData.length == 0) {
                    this.isEmpty = false
                } else {
                    this.isEmpty = true
                }
            })
        },
        // updateText() {
        //     this.$api.push(this.pushObj).then((res) => {
        //         console.log(res);
        //     })
        // },
        handleEdit(row, title) {
            if (row) {
                this.$refs['edit'].showEdit(row, title)
            } else {
                this.$refs['edit'].showEdit(row, title)
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.grid-content {
    padding: 0 10px 0;
    height: 87vh;
    // border: 1px solid #050350;
    display: flex;
    flex-direction: column;
}

.com_header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

::v-deep .el-card {
    height: 100% !important;


}

::v-deep .el-card__body {
    height: calc(100% - 117px) !important;
}

.el-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
}



.com_cont {
    height: 100% !important;
}

// .el-table {
//     height: 95% !important;
//     overflow: auto;
// }

::v-deep .el-input__inner {
    height: 30px;
}

::v-deep .el-input__suffix {
    right: 5px;
    transition: all .3s;
    display: flex;
    align-items: center;
}

::v-deep .el-empty {
    height: 90%;
}
</style>